import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserSettingOptionState, UserSettings, WidgetSettings } from '@model';
import { environment } from '@environment';
import { SxErrorService } from 'app/services/sx-error.service';
import { UserSettingOption } from '@enums';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  
  
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getMySettings(): Observable<UserSettings> {
    return this.http
      .get<UserSettings>(`${environment.apiEndpoint}/Settings`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  updateSettings(settings: UserSettings): Observable<UserSettings> {
    return this.http
      .post<UserSettings>(`${environment.apiEndpoint}/Settings`, settings)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  updateWidgetSettings(widgetSettings: WidgetSettings): Observable<WidgetSettings> {
    return this.http
      .post<WidgetSettings>(`${environment.apiEndpoint}/Settings/Widgets`, widgetSettings)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getMyAnalyzeFilterViewSettings(): Observable<UserSettingOptionState> {
    return this.http
      .get<UserSettingOptionState>(`${environment.apiEndpoint}/Settings/AnalyzeFilterViewSetting`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  updateAnalyzeFilterViewSetting(request: UserSettingOptionState): Observable<UserSettingOptionState>  {
    return this.http
      .post<UserSettingOptionState>(`${environment.apiEndpoint}/Settings/AnalyzeFilterViewSetting`, request)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
